<script setup lang="ts">
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";
import ListEmpty from "@/components/ui/ComplexList/ListEmpty.vue";
import { useIssueSelectorStore } from "@/store/issueSelector";

const store = useIssueSelectorStore();
</script>

<template>
  <ListEmpty
    data-search-results-anchor
    icon="general/search-results"
    tabindex="-1"
    aria-live="polite"
  >
    <p>
      {{ $t("issueSelector.message.noIssues") }}
      <br />
      {{ $t("issueSelector.message.resetFilters") }}
    </p>

    <template #after>
      <BaseButton variant="text" color="primary" @click="store.resetFiltersAndFetch()">
        {{ $t("issueSelector.resetFilters") }}
      </BaseButton>
    </template>
  </ListEmpty>
</template>
